var _          = require('underscore');
var $          = require('jquery');
var Core       = require('../core/core.js');


/**
 * Creates a footprint switcher
 *
 * @class
 */

class SwitcherItem extends Core {

    _defaults() {
        return {
            target: '.js-editor',
            fields: {
                'level': 0,
                'multilevel': false,
                'title': 'title',
                'thumbUrl': '',
                'data': null
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <% if(multilevel && level == 0) { %>
                <div class='editor__switcher__multileveltitle'>
                    <%- title %>
                </div>
            <% } else { %>
                <div class='editor__switcher__item js-editor__switcher__item'>
                    <div class='editor__switcher__item__inner'>
                        <div class='editor__switcher__item__inner__border'>
                            <% if(thumbUrl) { %>
                                <div class='editor__switcher__item__img'>
                                        <img src='<%= external_url(thumbUrl) %>'>
                                </div>
                            <% } %>
                            <div class='editor__switcher__item__title'>
                                <%- title %>
                            </div>
                        </div>
                    </div>
                </div>
            <% } %>
        `;

        super.render();

        /**
         * Click event
         *
         * @fires SwitcherItem#_clicked
         */

         $(this.$el).on('click', this._clicked);
    }

    /**
     * @event SwitcherItem#Cioui:SwitcherItem:clicked
     * @property {String}Cioui:SwitcherItem:clicked
     * @returns {Object} event - native click Event
     */

    _clicked(e){
        e.preventDefault();
        $(e.currentTarget).trigger('Cioui:SwitcherItem:clicked', e);
    }

    /**
     * Sets the button active
     */

    setActive(){
        this.$el.addClass('editor__switcher__item--active');
    }

    /**
     * Sets the button inactive
     */

    setInactive(){
        this.$el.removeClass('editor__switcher__item--active');
    }

    remove(){
        if (this.$el) {
            this.$el.remove();
        }
    }

}
module.exports = SwitcherItem;